"use client";

import { useState, type ReactNode } from "react";

type Tab = { key: string; label: string; content: ReactNode };

export function VideoDetailTabs({ tabs }: { tabs: Tab[] }) {
  const [active, setActive] = useState(tabs[0]?.key ?? "");
  const current = tabs.find((tab) => tab.key === active) ?? tabs[0];

  return (
    <>
      <div className="biaoqianqiehuan_tittle">
        <div className="qiehuan">
          <div className="qiehuan-track" role="tablist">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                type="button"
                role="tab"
                aria-selected={tab.key === current?.key}
                onClick={() => setActive(tab.key)}
                className={`qiehuan-item${tab.key === current?.key ? " on" : ""}`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="biaoqianqiehuan_content">
        <div className="qiehuan">
          <div className="qiehuan-track">
            <div className="qiehuan-panel" role="tabpanel">
              {current?.content}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
